<section>
    <div class="action-button-row">
      <div class="action-flex-container">
        <div class="action-button-container">
            <button mat-fab  aria-label="Edit Measure" >
              <mat-icon (click)="editMeasure()">edit</mat-icon>
            </button>
          </div>
        <div class="action-button-container">
          <button mat-fab aria-label="Delete Measure">
            <mat-icon (click)="deleteMeasure()">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </section>